import moment from "moment";
import { Tooltip, OverlayTrigger } from 'react-bootstrap';

//elements
import Button from '../../../components/CustomButton/CustomButton.jsx';
import RequiredStar from '../../../elements/RequiredStar.js';

//utils
import { dateToTimeFormat, getShortDateFormat } from "../../../utils/dateFormat";

const WagetypeRefetch = ({ t, refetch, dateTimeRules, lastUpdated, isLoading, extraNote = null, text = null, showAllWageTypes = false, onToggleShowAllWageTypes = null }) => {
    const shortDateFormat = getShortDateFormat(dateTimeRules);
    const lastUpdatedText = `${t('Last Updated')}: ${moment(lastUpdated).format(shortDateFormat)} - ${dateToTimeFormat(lastUpdated, dateTimeRules)}`
    return (
        <div className='d-flex justify-content-space-between align-items-center'>
            <div className="w-75">
                <RequiredStar />
                <span className='font-size-12 fw-bold'>
                    {text ? t(text) : t("Please select the payroll wage type carefully to ensure proper integration. If you are unable to see the wage type, please click the refetch icon.")}
                    &nbsp;({lastUpdatedText})
                </span>
                {extraNote && <p className='font-size-12 fw-bold'><RequiredStar /><RequiredStar />{extraNote}</p>}
                {typeof onToggleShowAllWageTypes === 'function' &&
                    <p className='font-size-12'>
                        <span className='cursor-pointer text-primary' onClick={() => onToggleShowAllWageTypes(!showAllWageTypes)}>
                            {showAllWageTypes ? t('Show only relevant wage types') : t("Can't find the wage type you need? Show all wage type categories")}
                        </span>
                    </p>
                }
            </div>
            <div>
                <OverlayTrigger
                    key="wagetype_refetch"
                    placement="left"
                    overlay={
                        <Tooltip id="tooltip-top">
                            {isLoading ? t("Refetching") + "..." : t("Refetch Wagetypes")}
                        </Tooltip>
                    }>
                    <Button icon_sm fill me2
                        onClick={refetch}
                        disabled={isLoading}
                    >
                        <i className="fa fa-sync fa-xl" />
                    </Button>
                </OverlayTrigger>
            </div>
        </div>

    )
};

export default WagetypeRefetch;